import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './index.ts';

/** 타입이 붙은 dispatch. 컴포넌트에서는 useDispatch 대신 이걸 쓴다. */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

/** 타입이 붙은 selector */
export const useAppSelector = useSelector.withTypes<RootState>();

/** 현재 로그인 사용자 (비로그인이면 null) */
export const useUser = () => useAppSelector((state) => state.auth.user);

/** 로그인 여부 */
export const useIsLogin = () => useAppSelector((state) => !!state.auth.user?.id);
